import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RenderMd from '../../util/markdown';

const ModalList = ({ data = {}, lookup = {}, columns = 2, className }) => {
  const renderData = () => {
    const rows = [];

    let currentRow = [];
    Object.keys(data).forEach((key, index) => {
      const rowData = String(data[key]) ? data[key] : '';
      if (index % columns === 0) {
        currentRow = [];
      }

      currentRow.push(
        <td key={`row-key-${index}`}>
          <strong>{lookup[key] || key}</strong>
        </td>
      );

      if (key === 'portalText') {
        currentRow.push(
          <td key={`row-data-${index}`}>
            <RenderMd className="custom-html-style" md={rowData} />
          </td>
        );
      } else {
        currentRow.push(<td key={`row-data-${index}`}>{rowData}</td>);
      }

      if (index % columns !== 0 || columns === 1 || Object.keys(data).length === index + 1) {
        rows.push(<tr key={`row-${index}`}>{currentRow}</tr>);
      }
    });

    return rows;
  };

  return (
    <div className={classNames('modal-list', className)}>
      <Table size="sm" striped>
        <tbody>{renderData()}</tbody>
      </Table>
    </div>
  );
};

ModalList.propTypes = {
  data: PropTypes.object,
  lookup: PropTypes.object,
  columns: PropTypes.number,
};

export default ModalList;
